import errorCodes from 'srcAlias/enums/errorCodes';

export const INIT_EVENT = 'INIT_EVENT';
export const ERROR_EVENT = 'ERROR_EVENT';
export const TRACK_EVENT = 'TRACK_EVENT';
export const TRACK_PAGEVIEW_EVENT = 'TRACK_PAGEVIEW_EVENT';
export const PIGGYBANK_EVENT = 'PIGGYBANK_EVENT';

export const initEvent = (event = {}) => ({
  type: INIT_EVENT,
  event,
});

export const errorEvent = (event = {}) => ({
  type: ERROR_EVENT,
  event: {
    category: errorCodes.CLIENT_GENERIC,
    ...event,
  },
});

export const trackEvent = (keyPath, rest = {}) => ({
  type: TRACK_EVENT,
  event: {
    keyPath,
    ...rest,
  },
});

export const trackPageViewEvent = (pageName, rest = {}) => ({
  type: TRACK_PAGEVIEW_EVENT,
  event: {
    pageName,
    ...rest,
  },
});

export const piggybankEvent = (
  currentSegmentName,
  currentPageName,
  event = {}
) => ({
  type: PIGGYBANK_EVENT,
  currentSegmentName,
  event,
  ...(event.type === 'onNavigate'
    ? {
        pageNameBeforeTransition:
          event.currentPageName !== currentPageName ? currentPageName : null,
      }
    : {
        currentPageName,
      }),
});
